import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import QRCode from 'qrcode.react';
import Config from '../../Config';

const config = new Config();

const rp = (v) => v != null ? Number(v).toLocaleString('id') : '0';

const CSS = `
.vs-root * { box-sizing: border-box; }
.vs-root {
    position: fixed; inset: 0;
    background: linear-gradient(150deg, #071829 0%, #0f2847 55%, #1c3f74 100%);
    display: flex; align-items: center; justify-content: center;
    overflow: auto; padding: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
.vs-card {
    width: 100%; max-width: 390px;
    background: #fff;
    border-radius: 22px;
    overflow: hidden;
    box-shadow: 0 30px 80px rgba(0,0,0,0.45), 0 6px 20px rgba(0,0,0,0.15);
    flex-shrink: 0;
}
.vs-head {
    background: linear-gradient(160deg, #0a2240 0%, #0d4a1e 100%);
    padding: 18px 20px 14px;
    position: relative;
    overflow: hidden;
}
.vs-head::before {
    content: '';
    position: absolute; inset: 0;
    background: repeating-linear-gradient(
        45deg,
        rgba(255,255,255,0.02) 0px,
        rgba(255,255,255,0.02) 1px,
        transparent 1px,
        transparent 14px
    );
}
.vs-head img { position: relative; z-index: 1; }
.vs-head-sub {
    position: relative; z-index: 1;
    margin-top: 8px;
    font-size: 9.5px; font-weight: 600; letter-spacing: 2px;
    text-transform: uppercase; color: rgba(255,255,255,0.45);
    text-align: center;
}
.vs-status-ok {
    padding: 11px 16px;
    background: linear-gradient(90deg, #16a34a 0%, #15803d 100%);
    font-size: 12.5px; font-weight: 700; color: #fff;
    text-align: center; letter-spacing: 0.5px;
    display: flex; align-items: center; justify-content: center; gap: 7px;
}
.vs-status-wait {
    padding: 11px 16px;
    background: linear-gradient(90deg, #d97706 0%, #b45309 100%);
    font-size: 12.5px; font-weight: 700; color: #fff;
    text-align: center; letter-spacing: 0.5px;
    display: flex; align-items: center; justify-content: center; gap: 7px;
}
.vs-ref-row {
    display: grid; grid-template-columns: 1fr 1fr;
    border-bottom: 1px solid #f1f5f9;
}
.vs-ref-cell {
    padding: 11px 16px;
}
.vs-ref-cell + .vs-ref-cell { border-left: 1px solid #f1f5f9; }
.vs-tiny { font-size: 9.5px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 3px; }
.vs-nominal-area {
    padding: 14px 18px 12px;
    background: #f8faff;
    border-bottom: 1px solid #e8f0fe;
    text-align: center;
}
.vs-nom-label { font-size: 9.5px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 1.2px; margin-bottom: 4px; }
.vs-nom-val { font-size: 24px; font-weight: 900; color: #0f2847; font-variant-numeric: tabular-nums; }
.vs-nom-val span { font-size: 14px; font-weight: 700; margin-right: 4px; opacity: 0.7; }
.vs-breakdown {
    border-bottom: 1px solid #f1f5f9;
}
.vs-bd-row {
    display: flex; justify-content: space-between; align-items: center;
    padding: 8px 18px;
    font-size: 12px;
    border-bottom: 1px solid #f8fafc;
}
.vs-bd-row:last-child { border-bottom: none; }
.vs-bd-label { color: #64748b; font-weight: 500; }
.vs-bd-val { font-weight: 700; color: #334155; }
.vs-bd-val.red { color: #dc2626; }
.vs-qr-area {
    display: flex; align-items: center; gap: 14px;
    padding: 14px 18px;
    background: #fafbfd;
    border-bottom: 1px solid #f1f5f9;
}
.vs-qr-frame {
    flex-shrink: 0;
    padding: 7px;
    background: #fff;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
}
.vs-qr-info { flex: 1; }
.vs-qr-kode { font-size: 10px; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: .8px; margin-bottom: 2px; }
.vs-qr-kode-val { font-size: 14px; font-weight: 800; color: #0f2847; margin-bottom: 6px; }
.vs-qr-note { font-size: 10px; color: #94a3b8; line-height: 1.5; }
.vs-foot {
    padding: 9px 18px;
    font-size: 9.5px; color: #b0bec5; text-align: center; letter-spacing: 0.3px;
}
.vs-notfound { padding: 36px 24px; text-align: center; }
.vs-notfound-icon {
    width: 60px; height: 60px; border-radius: 50%;
    background: #fef2f2;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 14px; font-size: 26px; color: #dc2626;
}
.vs-loading { padding: 52px 24px; text-align: center; }

@media (max-width: 500px) {
    .vs-root { padding: 0; align-items: flex-start; justify-content: flex-start; }
    .vs-card { border-radius: 0; max-width: 100%; min-height: 100svh; min-height: 100vh; }
    .vs-nom-val { font-size: 22px; }
}
`;

const VerifikasiSlip = ({ match }) => {
    const no_ref = match?.params?.ref || '';
    const [loading, setLoading] = useState(true);
    const [data, setData]       = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        if (!no_ref) { setLoading(false); setNotFound(true); return; }
        fetch(`${config.get_server_url()}/laporan/api/verifikasi-slip/${no_ref}/`)
            .then(res => {
                if (res.status === 404) { setNotFound(true); setLoading(false); return null; }
                return res.ok ? res.json() : null;
            })
            .then(json => {
                if (json)        { setData(json); setLoading(false); }
                else if (loading) { setNotFound(true); setLoading(false); }
            })
            .catch(() => { setNotFound(true); setLoading(false); });
    }, [no_ref]);

    const isValid = data?.status_validasi;

    return (
        <>
            <style>{CSS}</style>
            <div className="vs-root">
                <div className="vs-card">

                    {/* ── Header ── */}
                    <div className="vs-head">
                        <img
                            src={process.env.PUBLIC_URL + '/header-slip-setoran.png'}
                            alt="Bank Kalteng"
                            style={{ display: 'block', maxWidth: 230, width: '100%', margin: '0 auto' }}
                        />
                        <div className="vs-head-sub">Verifikasi Slip Setoran SWDKLLJ</div>
                    </div>

                    {/* ── Loading ── */}
                    {loading && (
                        <div className="vs-loading">
                            <Spin size="large" />
                            <div style={{ marginTop: 14, fontSize: 13, color: '#64748b', fontWeight: 500 }}>
                                Memverifikasi nomor referensi...
                            </div>
                        </div>
                    )}

                    {/* ── Not Found ── */}
                    {!loading && notFound && (
                        <div className="vs-notfound">
                            <div className="vs-notfound-icon">✕</div>
                            <div style={{ fontSize: 15, fontWeight: 800, color: '#dc2626', marginBottom: 10 }}>
                                Slip Tidak Ditemukan
                            </div>
                            <div style={{ fontSize: 12, color: '#64748b', lineHeight: 1.7 }}>
                                Nomor referensi<br />
                                <code style={{ fontSize: 11, background: '#f1f5f9', padding: '3px 8px', borderRadius: 5, color: '#334155', fontFamily: 'monospace', display: 'inline-block', marginTop: 6 }}>
                                    {no_ref || '—'}
                                </code>
                                <br /><br />
                                tidak ditemukan dalam sistem. Pastikan QR Code dipindai dari dokumen slip setoran resmi.
                            </div>
                        </div>
                    )}

                    {/* ── Valid Result ── */}
                    {!loading && data?.valid && (
                        <>
                            {/* Status bar */}
                            <div className={isValid ? 'vs-status-ok' : 'vs-status-wait'}>
                                <span style={{ fontSize: 14 }}>{isValid ? '✓' : '⚠'}</span>
                                {isValid ? 'SLIP TELAH DIVALIDASI BANK' : 'MENUNGGU VALIDASI BANK'}
                            </div>

                            {/* No.Ref + Tanggal */}
                            <div className="vs-ref-row">
                                <div className="vs-ref-cell">
                                    <div className="vs-tiny">No. Referensi</div>
                                    <div style={{ fontSize: 11, fontWeight: 800, color: '#0f2847', fontFamily: 'monospace', letterSpacing: 0.3 }}>
                                        {data.no_referensi}
                                    </div>
                                </div>
                                <div className="vs-ref-cell">
                                    <div className="vs-tiny">Tanggal</div>
                                    <div style={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}>{data.tanggal}</div>
                                </div>
                            </div>

                            {/* Total nominal — hero */}
                            <div className="vs-nominal-area">
                                <div className="vs-nom-label">Total Setoran SWDKLLJ</div>
                                <div className="vs-nom-val">
                                    <span>Rp</span>{rp(data.nominal)}
                                </div>
                            </div>

                            {/* Breakdown */}
                            <div className="vs-breakdown">
                                <div className="vs-bd-row">
                                    <span className="vs-bd-label">Pokok SWDKLLJ</span>
                                    <span className="vs-bd-val">Rp {rp(data.pokok)}</span>
                                </div>
                                <div className="vs-bd-row">
                                    <span className="vs-bd-label">Denda SWDKLLJ</span>
                                    <span className={`vs-bd-val${data.denda > 0 ? ' red' : ''}`}>Rp {rp(data.denda)}</span>
                                </div>
                            </div>

                            {/* QR + kode */}
                            <div className="vs-qr-area">
                                <div className="vs-qr-frame">
                                    <QRCode value={window.location.href} size={76} />
                                </div>
                                <div className="vs-qr-info">
                                    <div className="vs-qr-kode">Kode SAMSAT</div>
                                    <div className="vs-qr-kode-val">{data.kode_berkas}</div>
                                    <div className="vs-qr-note">
                                        Scan QR untuk verifikasi ulang. Data ini diterbitkan oleh Sistem E-SAMSAT dan bersifat resmi.
                                    </div>
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="vs-foot">
                                E-SAMSAT Kalimantan Tengah &nbsp;·&nbsp; Data read-only
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default VerifikasiSlip;
